import * as React from "react";

export default function BrandFeatures() {
  return (
    <div 
      className="tw-flex tw-flex-col tw-justify-center tw-px-16 tw-py-20 md:tw-py-32 tw-mt-20 md:tw-mt-36 tw-w-full tw-bg-lighter-green-bg">
      <div 
        className="tw-mb-0 max-md:tw-mb-2.5 tw-mx-auto"
        style={{maxWidth: "1293px"}}>
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-5 max-md:tw-flex-col">
          <BrandFeatureContent />
          <BrandFeatureImage />
        </div>
      </div>
    </div>
  );
}

function BrandFeatureContent() {
  return (
    <div 
      className="tw-flex tw-flex-col max-md:tw-ml-0 max-md:tw-w-full"
      style={{maxWidth: "500px"}}>
      <div className="tw-flex tw-flex-col md:tw-mt-16 tw-text-xl tw-leading-6 tw-text-neutral-800">
        <div className="tw-text-5xl md:tw-text-6xl tw-capitalize ">
          Brands Can Choose The Cause
        </div>
        <div className="tw-mt-5 tw-font-semibold">
          You choose the non-profit, cause or local project you'd like to
          fund or let the customer choose.
        </div>
        <div className="tw-mt-5">
          We update customers on project progress to show how shopping
          with Solvy directly impacts their local communities and beyond
        </div>
      </div>
    </div>
  );
}

function BrandFeatureImage() {
  return (
    <div className="tw-flex tw-flex-col md:tw-ml-5">
      <img
        loading="lazy"
        src="https://expertpeople.imgix.net/assets/images/forbrands-brands-choose.png"
        alt="Brand feature illustration showing cause selection interface"
        className="tw-object-contain tw-grow tw-w-full tw-rounded-none tw-aspect-[1.27]"
      />
    </div>
  );
}
